'use client';
import styled from 'styled-components';
import { colors } from '@/styles';
import Card from '@/ui/Card';

export const Commit = styled(Card).attrs((props) => ({}))`
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: space-between;
  background: ${colors.primary.white};
  border: 1px solid ${colors.secondary.lightGray2};
  border-radius: 5px;
  padding: 15px 25px;
`;

export const CommitMessage = styled.div`
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 10px;
  margin-top: 10px;
  & > * {
    flex: 1;
    white-space: nowrap;
    &:first-child,
    &:last-child {
      flex: 0;
    }
  }
`;

export const Timestamp = styled.span`
  padding-left: 0.5em;
`;
